import { Outlet, RouteObject } from 'react-router-dom';
import { Loadable } from '@sib/ui';
import { paths } from '@spendbrain/config/paths';
import { DocumentNotFound } from './components';

export const routes: RouteObject[] = [
  {
    path: paths.documents.root,
    element: <Outlet />,
    children: [
      {
        path: paths.documents.root,
        element: (
          <Loadable component={() => import('./pages/DocumentsRepository')} />
        ),
      },
      {
        path: paths.documents.preview,
        element: (
          <Loadable component={() => import('./pages/DocumentPreviewPage')} />
        ),
      },
      {
        path: paths.documents.document,
        element: (
          <Loadable component={() => import('./pages/DocumentViewerPage')} />
        ),
      },
      {
        path: paths.documents.any,
        element: <DocumentNotFound />,
      },
    ],
  },
];
